export enum StepperStatusEnum {
    VISIT = 'VISIT',
    CREATE = 'CREATE',
    EMPTY = 'EMPTY'
}
